<template lang="pug">
.diagnosticsItemPage
  template(v-if="itemController.isLoading.value")
    ui-loader.loader
  template(v-else-if="itemController.data.value")
    router-view(
      :item-controller="itemController"
      :state-controller="stateController"
    )
</template>

<script lang="ts" setup>
import { onUnmounted, watch } from 'vue'
import store from '@/store'
import DiagnosticsItemController from '@diagnostics/controllers/DiagnosticsItemController'
import DiagnosticsItemStateController from '@diagnostics/controllers/DiagnosticsItemStateController'
import { useRouter } from 'vue-router'

// Props
interface Props {
  id: number
}
const props = defineProps<Props>()

// Diagnostics item controller
const itemController = DiagnosticsItemController()

// State controller
const stateController = DiagnosticsItemStateController()

watch(
  () => props.id,
  () => {
    itemController.request(props.id)
    if (store.user.isAuthenticated.value) stateController.request(props.id)
  },
  { immediate: true }
)

const router = useRouter()
const onRequestDiagnosticsItemError = (errors: string[]) => {
  // errors.forEach(str => store.ui.notices.newError(str, '', { duration: 3000 }))
  router.push({ name: 'DiagnosticsList' })
}

itemController.$on('request-fetch-diagnostics-item-error', onRequestDiagnosticsItemError)

onUnmounted(() => {
  itemController.$off('request-fetch-diagnostics-item-error', onRequestDiagnosticsItemError)
})
</script>

<style lang="sass" scoped>
.diagnosticsItemPage
  > .loader
    margin: 0 auto
</style>
